import moment from 'moment';
export default {
  filters: {
    // 3桁ごとにコンマを入れるフィルター
    numberFormat: function (value) {
      if (!value || value == 0) return 0;
      value = value.toString();
      return value.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
    // 00:00:00を00:00に変更するフィルター
    timeShorten: function(value) {
      if (!value) return '';
      return value.slice(0, 5);
    },
    formatDateTime: function(value) {
      if (!value) return '';
      const date = moment(value);
      const dayOfWeek = ['日', '月', '火', '水', '木', '金', '土'][date.day()];
      return `${date.format('YYYY年M月D日')}（${dayOfWeek}）${date.format('HH:mm')}`;
    },
    formatDate: function(value) {
      if (!value) return '';
      const date = moment(value);
      const dayOfWeek = ['日', '月', '火', '水', '木', '金', '土'][date.day()];
      return `${date.format('YYYY年M月D日')}（${dayOfWeek}）`;
    }
  },
  props: {
    value: {},
    reservedFee: {},
    refundFee: {},
  },
  methods: {
    closedCancelPage() {
      this.$emit("closedCancelPage");
    },
    cancelReservation(id) {
      this.$emit("cancelReservation", id);
    }
  },
}
